var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-segment",class:{'no-container-background': !_vm.isSupportWebgl.webgl}},[_c('div',{staticClass:"person-img"},[_c('spine-model',{attrs:{"massInfo":_vm.massInfo},on:{"changeSpine":_vm.changeSpine}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }